import type { Locale } from 'next-intl';

import { getRoute } from '@/constants';
import type { JobDetailDto, JobSearchDto } from '@/modules/job/contracts';

import type { JobDetailVM } from '../models/job-detail.view-model';
import type { JobSearchVM } from '../models/job-list-item.view-model';

export const jobSearchDtoToVM = (job: JobSearchDto, locale: Locale): JobSearchVM => {
	return {
		id: job.id,

		companyDescription: '',
		companyName:        '',
		description:        job.description,
		detailUrl:          getRoute.jobs.detail(job.id),
		eligibility:        job.qualification ?? '',
		endDate:            null,
		entryUrl:           getRoute.jobs.apply(job.id),
		hasApplied:         job.hasApplied,
		hasSaved:           job.hasSaved,
		location:           `${job.location.district[locale]}, ${job.location.province[locale]}`,
		startDate:          new Date(job.postedAt),
		summary:            job.summary,
		title:              job.title,
		workHours:          job.workHours ?? '-',

		coverImage: {
			caption: 'to do',
			url:     job.coverImage || '',
		},
		salary: {
			max: job.estimatedSalaryMax ?? 0,
			min: job.estimatedSalaryMin ?? 0,
		},
	};
};

// eslint-disable-next-line complexity
export const jobDetailDtoToVM = (jobDto: JobDetailDto): JobDetailVM => {
	return {
		id: jobDto.id,

		detailUrl:   getRoute.jobs.detail(jobDto.id),
		entryUrl:    getRoute.jobs.apply(jobDto.id),
		expiredDate: new Date(jobDto.expiredAt),
		hasApplied:  jobDto.hasApplied,
		hasSaved:    jobDto.hasSaved,
		startDate:   new Date(jobDto.postedAt),
		title:       jobDto.title,

		company: {
			...jobDto.company,
			capital:          jobDto.company.capital as never ?? '' as never,
			ceo:              jobDto.company.ceo as never ?? '' as never,
			corporateWebsite: '' as never,
			mainOffice:       '' as never,
		} as never,
		detail: {
			baseSalary:        jobDto.salaryIncreasePolicy ?? '',
			benefits:          jobDto.employeeBenefits ?? '',
			bonusPolicy:       jobDto.bonusPolicy ?? '',
			description:       jobDto.description,
			employmentType:    jobDto.employmentType,
			location:          jobDto.locationDetail ?? '',
			probation:         jobDto.probationPeriod ?? '',
			requirements:      jobDto.qualification ?? '',
			salaryExample:     jobDto.salaryExamples ?? [],
			salaryIncrease:    jobDto.salaryExpectation ?? '',
			salaryProgression: jobDto.salaryIncreasePolicy ?? '',
			summary:           jobDto.summary,
			timeOff:           jobDto.leavePolicy ?? '',
			workingHours:      jobDto.workHours ?? '',

			testimonials: jobDto.testimonials
				? jobDto.testimonials.map(job => ({
						quote:  job.quote ?? '',
						role:   job.role ?? '',
						tenure: job.tenure ?? '',
						title:  job.title ?? '',
					}))
				: [],
		},
		howToApply: {
			applicationInstructions: jobDto.applicationInstructions ?? '',
			contactInfo:             jobDto.contactInfo ?? '',

			applicationSteps: [
				{
					description: 'random',
					stepNumber:  1,
				},
				{
					description: 'random',
					stepNumber:  2,
				},
				{
					description: 'random',
					stepNumber:  3,
				},
			],
		},
		images: jobDto.images.map(img => ({
			caption: '',
			url:     img,
		})),
		specialInfo: {
			description: jobDto.specialDescription ?? '',
			image:       jobDto.specialImage ?? '',
			topic:       jobDto.specialTopic ?? '',
		},
	};
};
